import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import JSONEditor from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/fr';
import { getMatchData, updateMatch } from '../../api/index.js';
import { useFetch } from '../../api/useFetch.js';
import jsonlint from 'jsonlint-mod';
import { detailedDiff } from 'deep-object-diff';




function JsonEditorPage({ data, url }) {

  const [open, setOpen] = useState(false)

  const [jsonData, setJsonData] = useState({});

  const [isJsonValid, setIsJsonValid] = useState(false)
  const [jsonToSend, setJsonToSend] = useState()

  useEffect( ()=> {
    setIsJsonValid(!jsonData.error)
  }, [jsonData])

  function handleJsonChange(json) {
    setJsonData(json);
  }

  const URLsaveMatchData = useCallback(() => {
    if(jsonToSend && jsonToSend._id)
      return url(jsonToSend._id, jsonToSend)
    
    return () => {}

  }, [jsonToSend, url])

  const [jsonUpdated, loading] = useFetch(URLsaveMatchData)

  const handlePreSave = () => {
    setOpen(true)
  }

  const handleSave = () => {
    // Sauvegarder le nouveau json
    setOpen(false)
    const {jsObject} = jsonData

    if(jsObject && jsObject._id && isJsonValid){
      setJsonToSend(jsObject)
    }
      
  };

  return (
    <Box sx={{display : 'flex', alignItems : 'center', flexDirection : 'column', mb : 2}}>
      <JSONEditor
        placeholder={data} // data to display
        onChange={handleJsonChange}
        theme="terminal"
        locale={locale}
        colors={{
          string: "#DAA520" // overrides theme colors with whatever color value you want
        }}
        width='100%'
      />
      <Button variant="contained" onClick={handlePreSave} disabled={!isJsonValid || jsonData.jsObject===jsonToSend}>
        Sauvegarder
      </Button>

      <Notif open={open} setOpen={setOpen} confirm={handleSave} initialData={data} futurData={jsonData.jsObject}/>
    </Box>
    
  );
}

const Notif = ({changes, open, setOpen, confirm,  initialData, futurData}) => {

  const [differences, setDifferences] = useState([])

  useEffect(() => {
    if(!initialData || !futurData)
      return

    const dif = detailedDiff(initialData, futurData);

    setDifferences(dif)


  }, [futurData, initialData])



  const handleClickOpen = () => {
      setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
      >
          <DialogTitle id="alert-dialog-title">
          {"Vérifier les modifications avant de soumettre"}
          </DialogTitle>
          <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Modifications :
            <pre>{JSON.stringify(differences, function(key, value) {
  return (typeof value === 'undefined') ? '' : value;
}, 2)}</pre>
          </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button onClick={confirm} autoFocus>
              Confirmer
          </Button>
          </DialogActions>
      </Dialog>
  )
}


export default JsonEditorPage;